import {
    IEditorGroupsService, IFindGroupScope, GroupDirection, GroupLocation, GroupsOrder,
    CacheTypenames, IClientConfigurationService, GroupIdentifier, ClientTypes,
    IAddGroupOptions, IEditorGroup, findAllByTypename, IEditorPart,
} from '@workbench-stack/core';
import { ClientTypes as CommonTypes } from '@common-stack/client-react';
import { inject, injectable } from 'inversify';
import { ApolloClient } from 'apollo-client';
import { InMemoryCache } from 'apollo-cache-inmemory';
import * as parts from '../../core';

@injectable()
export abstract class AbstractEditorGroupService implements IEditorGroupsService {
    constructor(
        @inject(ClientTypes.IConfigurationService)
        protected readonly configurationService: IClientConfigurationService,
        @inject(CommonTypes.ApolloClient)
        protected client: ApolloClient<any>,
        @inject(CommonTypes.InMemoryCache)
        protected cache: InMemoryCache,
        @inject(CommonTypes.UtilityClass)
        protected utility,
        @inject(CommonTypes.Logger)
        protected logger: any,
    ) {

    }

    public get activeGroup() {
        const groups = this.groups;
        return parts.getActiveGroup(groups);
    }

    public findGroup(scope: IFindGroupScope, source: number, wrap?: boolean) {
        return parts.findGroup(scope, source, this.groups, wrap);
    }

    public addGroup(location: GroupIdentifier, direction: GroupDirection, options?: IAddGroupOptions): IEditorGroup {
        const modifiedGroups = parts.addGroup(location, direction, this.groups, options);
        this.setGroups([...modifiedGroups]);

        return parts.getGroup(location, modifiedGroups);
    }

    public activateGroup(group: number) {
        const groups = this.groups;
        const activatedGroupId = parts.getActiveGroup(groups).id;

        if (activatedGroupId === group) {
            return;
        }
        const modifiedGroups = parts.activateGroup(group, groups);
        this.setGroups(modifiedGroups);
        return parts.getGroup(group, modifiedGroups);
    }

    public getGroup(identifier: number) {
        // TODO we can directly get the group from Apollo Cache
        return parts.getGroup(identifier, this.groups);
    }

    public getGroups(order = GroupsOrder.CREATION_TIME) {
        return parts.getGroups(order, this.groups);
    }

    public abstract applyLayout(layout: IEditorPart);

    public removeGroup(group: IEditorGroup | GroupIdentifier): IEditorGroup[] {
        const result = parts.removeGroup(group, this.groups);
        return result || [];
    }

    public abstract get groups();

    public abstract setGroups(data: IEditorGroup[]);

}

